export type LogoTypeKey =
    | 'wordmark'
    | 'mascot'
    | 'emblem'
    | 'abstract'
    | 'symbol'
    | 'combo'
    | 'open-to-ideas';

export interface LogoType {
    key: LogoTypeKey;
    title: string;
    description: string;
    imageSrc: string;
    attribution?: string;
}

export default [
    {
        key: 'wordmark',
        title: __('Wordmark'),
        description: __('Unique typographic treatments help them remember your name.'),
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/wordmark.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: __('by VU design'),
    },
    {
        key: 'pictorial',
        title: __('Pictorial'),
        description: __(
            'Link your business with the image of your choice: instant brand personality.'
        ),
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/pictorial.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: __('by milan artworks'),
    },
    {
        key: 'abstract',
        title: __('Abstract'),
        description: __('Truly custom abstract images stand for you and you alone.'),
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/abstract.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: __('by Fulcro'),
    },
    {
        key: 'mascot',
        title: __('Mascot'),
        description: __('Fun brands start with a memorable character.'),
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/mascot.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: __('by Crealiza'),
    },
    {
        key: 'emblem',
        title: __('Emblem'),
        description: __('Build a legacy with a badge, seal or crest.'),
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/emblem.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: __('by Dexterous"'),
    },
    {
        key: 'combination',
        title: __('Combination'),
        description: __('Words and images mixed together to create the perfect combo.'),
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/combination.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: __('by Rozak ifandi'),
    },
    {
        key: 'open-to-ideas',
        title: __('Open to ideas'),
        description: __('I’d like to see different concepts to decide what works for my brand.'),
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/not-sure-yet.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
    },
];
